import Text from './Text';

const SubHeading = Text.withComponent('h2');

SubHeading.defaultProps = {
  fontSize: 2
};

export default SubHeading;
